import React from "react";
import CreatePortsCard from "./PortsCard";

function PortsCardModal({ handleClose, cardType, portsList }) {

    return (
        <div className="modal oct_display-block">
            <div className="create-user-modal">

                <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                </button>

                <div className="create-inventory-box">
                    <CreatePortsCard handleClose={handleClose} cardType={cardType} data={portsList}/>
                </div>
            </div>
        </div>
    )

}


export default PortsCardModal;